import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '../components/icons/NavIcons';
import PageHeader from '../components/PageHeader';

const CreditsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const openSourceLibraries = [
    { name: 'Inter Font', url: 'https://rsms.me/inter/', license: 'SIL OFL 1.1' },
    { name: 'Streamline Icons', url: 'https://streamlinehq.com', license: 'Free' },
    { name: 'React', url: 'https://reactjs.org/', license: 'MIT' },
    { name: 'Leaflet', url: 'https://leafletjs.com/', license: 'BSD-2-Clause' },
    { name: 'Supabase', url: 'https://supabase.com/', license: 'Apache 2.0' },
    { name: 'Tailwind CSS', url: 'https://tailwindcss.com/', license: 'MIT' },
    { name: 'Vite', url: 'https://vitejs.dev/', license: 'MIT' },
    { name: 'i18next', url: 'https://www.i18next.com/', license: 'MIT' },
  ];

  const dataSources = [
    { name: 'OpenStreetMap', url: 'https://www.openstreetmap.org/', license: 'ODbL' },
    { name: 'OpenTopoMap', url: 'https://opentopomap.org/', license: 'CC-BY-SA' },
    { name: 'ESRI', url: 'https://www.esri.com/', license: 'Proprietary' },
    { name: 'StadiaMaps', url: 'https://stadiamaps.com/', license: 'Proprietary' },
  ];

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Header */}
      <PageHeader title={t('credits.page.title')} />

      {/* Contenu */}
      <div className="p-4 space-y-6">
        {/* Contributeurs */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-h2 text-bleu2 mb-4">
            {t('credits.page.contributors.title')}
          </h2>
          <p className="text-gray-700 mb-4">
            {t('credits.page.contributors.description')}
          </p>
          <div className="space-y-2">
            <div>
              <h3 className="font-semibold">{t('credits.page.contributors.developer')}</h3>
              <p className="text-gray-600">Maploop Org</p>
            </div>
          </div>
        </div>

        {/* Technologies utilisées */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-h2 text-bleu2 mb-4">
            {t('credits.page.contributors.technologies')}
          </h2>
          <div className="space-y-2">
            <p className="text-gray-600">React • TypeScript • Supabase</p>
            <p className="text-gray-600">Azure • Leaflet • OpenStreetMap</p>
            <p className="text-gray-600">Tailwind CSS • Vite • i18next</p>
          </div>
        </div>

        {/* Licences Open Source */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-h2 text-bleu2 mb-4">
            {t('credits.page.openSource.title')}
          </h2>
          <p className="text-gray-700 mb-4">
            {t('credits.page.openSource.description')}
          </p>
          
          <div className="space-y-3">
            {openSourceLibraries.map((lib, index) => (
              <div key={index} className="flex justify-between items-center py-2 border-b last:border-b-0">
                <a 
                  href={lib.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-bleu2 hover:underline font-medium"
                >
                  {lib.name}
                </a>
                <span className="text-sm text-gray-500">{lib.license}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Sources de données */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-h2 text-bleu2 mb-4">
            {t('credits.page.dataSources.title')}
          </h2>
          <p className="text-gray-700 mb-4">
            {t('credits.page.dataSources.description')}
          </p>
          
          <div className="space-y-4">
            <div>
              <h3 className="font-semibold mb-2">
                {t('credits.page.dataSources.userGenerated')}
              </h3>
              <p className="text-gray-600 text-sm">
                {t('credits.page.dataSources.userGeneratedDesc')}
              </p>
            </div>

            <div>
              <h3 className="font-semibold mb-2">
                {t('credits.page.dataSources.openData')}
              </h3>
              <p className="text-gray-600 text-sm mb-3">
                {t('credits.page.dataSources.openDataDesc')}
              </p>
              <div className="space-y-2">
                {dataSources.map((source, index) => (
                  <div key={index} className="flex justify-between items-center py-2 border-b last:border-b-0">
                    <a 
                      href={source.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-bleu2 hover:underline"
                    >
                      {source.name}
                    </a>
                    <span className="text-sm text-gray-500">{source.license}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Remerciements */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-h2 text-bleu2 mb-4">
            {t('credits.page.thanks.title')}
          </h2>
          <p className="text-gray-700">
            {t('credits.page.thanks.description')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CreditsPage;
